import React from 'react';
import { Translate } from 'react-redux-i18n';
import ScrollComponent from '../ScrollComponent';

const handleClickItem = (props, item) => () => {
  props.clickItemSearch(item.code, item.displayCode);
};

export default function(props) {
  const {
    parentListSearchRef,
    listSearchRef,
    currentItemActive,
    isCoveredWarrant,
  } = props;
  let className = 'drop-search drop-mecus scroll-drop drop-10';

  if (props.isShow) {
    className = [className, 'show'].join(' ');
  }

  return (
    <div className={className}>
      <ScrollComponent
        appendStyle={{ maxHeight: 280 }}
        scrollRef={parentListSearchRef}
      >
        {props.listFilter.length === 0 ? (
          <a className="dropdown-item" href="#">
            <Translate
              value={
                isCoveredWarrant
                  ? 'common.NO_MATCHED_CW'
                  : 'common.NO_MATCHED_STOCK'
              }
            />
          </a>
        ) : (
          props.listFilter.map((item, index) => {
            const className =
              index === currentItemActive
                ? 'dropdown-item hover'
                : 'dropdown-item';
            return (
              <a
                className={className}
                href="#"
                key={item.displayCode}
                ref={el => (listSearchRef[index] = el)}
                onClick={handleClickItem(props, item)}
              >
                <span className={isCoveredWarrant ? 'w-25' : 'w-20'}>
                  {item.displayCode}
                </span>
                <span
                  className={`${
                    isCoveredWarrant ? 'w-75' : 'w-55'
                  } text-truncate`}
                  title={item.codeName}
                >
                  {item.codeName}
                </span>
                {!isCoveredWarrant && (
                  <span className="w-25 text-right">
                    {item.exchange.toUpperCase()}
                  </span>
                )}
              </a>
            );
          })
        )}
      </ScrollComponent>
    </div>
  );
}
